module.exports = __webpack_public_path__ + "static/uoh-faec30b911883835d9a6d9403b10a1c8.svg";